<template>
  <div>
    <div :style="{ fontSize: fonts.font30 + 'px' }"
    >Unlock Account</div>
    <div class="textArea" :style="{ fontSize: fonts.font16 + 'px' }">
      Unlock Account # {{siFormUser}}.
    </div>
    <sendPin
      v-bind:acct="siFormUser"
      optType="unlock"
      type="Unlock Account"
      opt1="Unlock Account"
      opt2=""
      opt3=""
      opt4="">
    </sendPin>
  </div>
</template>

<script>
// eslint-disable-next-line
import utl from '../myUtils';
import sendPin from './sendPin';

export default {
  components: {
    sendPin,
  },
  name: 'zUnlock',
  data() {
    return {
      phone: '',
      pin: '',
      how: 'Text',
      access: 'one',
    };
  },
  computed: {
    fonts() {
      return this.$store.getters.getFonts;
    },
    cun() {
      return this.$store.getters.getCuNumber;
    },
    member() {
      return this.$store.getters.getMember;
    },
    siFormUser() {
      return this.$store.getters.getSiFormUser;
    },
    navVer() {
      return this.$store.getters.getNavVer;
    },
  },
  methods: {
    submitRequest() {
      const savePhone = this.phone;
      this.phone = utl.fmtPhone(this.phone);
      if (this.phone === 'invalid phone#') {
        this.showAlert('Please enter a valid phone number');
        this.phone = savePhone;
        return;
      }
      const cuInfo = {};
      cuInfo.cun = this.cun;
      cuInfo.acct = this.siFormUser;
      cuInfo.type = this.how;
      cuInfo.phone = this.phone;
      cuInfo.navVer = this.navVer;
      // utl.diag(`navVer: ${cuInfo.navVer}`);
      // utl.diag(cuInfo);
      this.wsSend('c4RequestPin', cuInfo);
      this.showConfirm('Sending request to server...');
    },
    inputGotFocus() {
      this.hideConfirm();
      this.hideAlert();
    },
    cancel() { // Go Back
      window.history.back();
    },
    submitPin() {
      const savePin = this.pin;
      this.pin = utl.fmtPin(this.pin);
      if (this.pin === 'invalid pin') {
        this.showAlert('Please enter a valid PIN number');
        this.pin = savePin;
        return;
      }
      const cuInfo = {};
      cuInfo.cun = this.cun;
      cuInfo.acct = this.siFormUser;
      cuInfo.pin = this.pin;
      cuInfo.navVer = this.navVer;
      // utl.diag(`navVer: ${cuInfo.navVer}`);
      this.wsSend('c4ValidatePin', cuInfo);
      this.showConfirm(`Checking for valid pin for account ${this.siFormUser}.`);
    },
    hideConfirm() {
      this.$store.commit('setConfirmShow', false);
    },
    showConfirm(message) {
      this.$store.commit('setConfirmMessage', message);
    },
    hideAlert() {
      this.$store.commit('setAlertShow', false);
    },
    showAlert(message) {
      this.$store.commit('setAlertMessage', message);
    },
    diag(message) {
      this.$store.commit('showDiag', message);
    },
    writeDiag(message) {
      this.$store.commit('putDiag', message);
    },
    wsSend(rpc, myObject) {
      const data = Object.assign({}, myObject);
      data.rpcName = rpc;
      this.$store.commit('sendObjToServer', data);
    },
    goBack() {
      // this.$store.commit('setPageIndex', 0); /* go to pg 0 since we aren't logged in */
      window.history.back();
    },
  },
};
</script>

<style scoped>
  h1 {
    font-weight: bold;
  }
  .radioBox {
    display: inline-block;
    border: solid 2px black;
    padding: 10px 10px 10px 10px; /* top, right, bottom, left*/
    max-width: 350px;
  }
  .gHead {
    font-weight: bold;
    color: black;
  }
  .recoveryBox {
    display: inline-block;
    border: solid 2px black;
    padding: 10px 10px 10px 10px; /* top, right, bottom, left*/
    margin-top: 10px;
    max-width: 350px;
  }
  .recPin {
    position: relative;
    display: inline-flex;
    horiz-align: center;
    width: 200px;
  }
  .btnGreen {
    background-color: lime;
    color: black;
    font-weight: bold;
    top: 10px;
    left: -10px;
  }
  .btnRed {
    background-color: red;
    color: black;
    font-weight: bold;
    top: 10px;
    right: -10px;
  }
  .warn {
    color: red;
    font-weight: bold;
    background-color: white;
    border: solid 1px red;
  }

</style>



// WEBPACK FOOTER //
// src/components/unlockAcct.vue